/* eslint-disable @typescript-eslint/no-unused-vars, react-hooks/exhaustive-deps, import/no-anonymous-default-export, no-useless-escape */
import api from '../services/api';
import React,{useState,useEffect} from 'react';
import Layout from '../components/layout/Layout';
import StatCard from '../components/common/StatCard';
import {Input,Select} from '../components/common/FormField';
import {getCurrencySymbol} from '../utils/locale';

const BASE=process.env.REACT_APP_API_URL;
const af=(p:string,o:any={})=>fetch(`${BASE}${p}`,{...o,headers:{...o.headers,Authorization:`Bearer ${localStorage.getItem('accessToken')}`,'Content-Type':'application/json'}}).then(r=>r.json());

export default function CommunicationsPage(){
  const [tab,setTab]=useState<'sms'|'whatsapp'|'email'|'bulk'|'templates'>('sms');
  const [smsForm,setSmsForm]=useState({mobile:'',message:''});
  const [waForm,setWaForm]=useState({mobile:'',message:''});
  const [emailForm,setEmailForm]=useState({to:'',subject:'',html:'',text:''});
  const [bulkForm,setBulkForm]=useState({mobiles:'',message:''});
  const [apptForm,setApptForm]=useState({patientName:'',mobile:'',email:'',doctorName:'',date:'',time:''});
  const [labForm,setLabForm]=useState({patientName:'',mobile:'',email:'',reportType:'CBC - Complete Blood Count'});
  const [billForm,setBillForm]=useState({patientName:'',mobile:'',email:'',billNumber:'',amount:''});
  const [result,setResult]=useState<any>(null);
  const [loading,setLoading]=useState(false);
  const [msg,setMsg]=useState('');

  const send=async(endpoint:string,body:any)=>{
    setLoading(true);setResult(null);
    try{
      const r=await af(`/notifications/${endpoint}`,{method:'POST',body:JSON.stringify(body)});
      setResult(r.data||r);
      setMsg('Sent successfully!');
    }catch(e:any){setMsg('Error: '+e.message);}
    finally{setLoading(false);setTimeout(()=>setMsg(''),3000);}
  };

  const TEMPLATES=[
    {name:'Appointment Reminder',icon:'📅',desc:'Remind patient of upcoming appointment',fields:['patientName','mobile','email','doctorName','date','time'],endpoint:'appointment-reminder'},
    {name:'Lab Report Ready',icon:'🔬',desc:'Notify when lab report is available',fields:['patientName','mobile','email','reportType'],endpoint:'lab-report-ready'},
    {name:'Bill Payment Receipt',icon:'💰',desc:'Send payment confirmation',fields:['patientName','mobile','email','billNumber','amount'],endpoint:'bill-receipt'},
    {name:'Video Consult Link',icon:'📹',desc:'Send telemedicine join link',fields:['patientName','mobile','email','doctorName','joinUrl','scheduledAt'],endpoint:'teleconsult-link'},
  ];

  return(
    <Layout title="Communications & Notifications">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-5">
        <StatCard label="SMS Gateway" value="MSG91" icon="📱" color="blue" sub="Configured"/>
        <StatCard label="WhatsApp" value="Business API" icon="💬" color="green" sub="Integrated"/>
        <StatCard label="Email" value="SMTP" icon="📧" color="purple" sub="Ready"/>
        <StatCard label="Push Notify" value="Firebase" icon="🔔" color="amber" sub="Optional"/>
      </div>

      <div className="flex gap-2 mb-5 flex-wrap">
        {[['sms','📱 SMS'],['whatsapp','💬 WhatsApp'],['email','📧 Email'],['bulk','📣 Bulk SMS'],['templates','🎨 Templates']].map(([t,l])=>(
          <button key={t} onClick={()=>setTab(t as any)} className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${tab===t?'bg-[#02357A] text-white shadow':'bg-white border border-slate-200 text-slate-600 hover:bg-slate-50'}`}>{l}</button>
        ))}
      </div>

      {msg&&<div className={`mb-4 p-3 rounded-lg text-sm border ${msg.includes('!')?'bg-green-50 text-green-700 border-green-200':'bg-red-50 text-red-700 border-red-200'}`}>{msg}</div>}

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <div>
          {tab==='sms'&&(
            <div className="card p-5">
              <h3 className="font-bold text-slate-800 mb-4">📱 Send SMS</h3>
              <div className="space-y-3 mb-4">
                <div><label className="label">Mobile Number *</label><Input value={smsForm.mobile} onChange={e=>setSmsForm({...smsForm,mobile:e.target.value})} placeholder="+254 712 345678" type="tel"/></div>
                <div>
                  <label className="label">Message *</label>
                  <textarea className="input" rows={4} value={smsForm.message} onChange={e=>setSmsForm({...smsForm,message:e.target.value})} placeholder="Type your SMS message..."/>
                  <p className={`text-xs mt-1 ${smsForm.message.length>160?'text-red-500':'text-slate-400'}`}>{smsForm.message.length}/160 chars {smsForm.message.length>160?`(${Math.ceil(smsForm.message.length/160)} SMS)`:''}</p>
                </div>
              </div>
              <button onClick={()=>send('sms',smsForm)} disabled={loading||!smsForm.mobile||!smsForm.message} className="btn-primary w-full">{loading?'Sending...':'📱 Send SMS'}</button>
              <div className="mt-4 p-3 bg-slate-50 rounded-lg text-xs text-slate-500">
                <p className="font-medium mb-1">Provider: MSG91</p>
                <p>Transactional SMS via DLT-registered sender ID. Delivery report available in MSG91 dashboard.</p>
              </div>
            </div>
          )}

          {tab==='whatsapp'&&(
            <div className="card p-5">
              <h3 className="font-bold text-slate-800 mb-4">💬 Send WhatsApp</h3>
              <div className="space-y-3 mb-4">
                <div><label className="label">Mobile Number *</label><Input value={waForm.mobile} onChange={e=>setWaForm({...waForm,mobile:e.target.value})} placeholder="+254 712 345678" type="tel"/></div>
                <div>
                  <label className="label">Message *</label>
                  <textarea className="input" rows={5} value={waForm.message} onChange={e=>setWaForm({...waForm,message:e.target.value})} placeholder="WhatsApp message (supports *bold*, _italic_, line breaks)"/>
                </div>
              </div>
              <button onClick={()=>send('whatsapp',waForm)} disabled={loading||!waForm.mobile||!waForm.message} className="btn-success w-full">{loading?'Sending...':'💬 Send WhatsApp'}</button>
              <div className="mt-4 p-3 bg-green-50 rounded-lg text-xs text-green-700">
                <p className="font-medium mb-1">📱 WhatsApp Business API</p>
                <p>Uses Meta Cloud API. Patient must have opted-in to receive WhatsApp messages. Supports text, images, and template messages.</p>
              </div>
            </div>
          )}

          {tab==='email'&&(
            <div className="card p-5">
              <h3 className="font-bold text-slate-800 mb-4">📧 Send Email</h3>
              <div className="space-y-3 mb-4">
                <div><label className="label">To Email *</label><Input value={emailForm.to} onChange={e=>setEmailForm({...emailForm,to:e.target.value})} placeholder="patient@email.com" type="email"/></div>
                <div><label className="label">Subject *</label><Input value={emailForm.subject} onChange={e=>setEmailForm({...emailForm,subject:e.target.value})} placeholder="Email subject"/></div>
                <div><label className="label">Message (HTML supported)</label><textarea className="input font-mono text-xs" rows={6} value={emailForm.html} onChange={e=>setEmailForm({...emailForm,html:e.target.value})} placeholder="<h2>Dear Patient,</h2><p>Your appointment is confirmed...</p>"/></div>
              </div>
              <button onClick={()=>send('email',emailForm)} disabled={loading||!emailForm.to||!emailForm.subject} className="btn-primary w-full">{loading?'Sending...':'📧 Send Email'}</button>
              <div className="mt-4 p-3 bg-slate-50 rounded-lg text-xs text-slate-500">
                <p className="font-medium mb-1">SMTP Configuration</p>
                <p>Configure SMTP credentials in .env file. Supports Gmail, SendGrid, AWS SES, and any SMTP provider.</p>
              </div>
            </div>
          )}

          {tab==='bulk'&&(
            <div className="card p-5">
              <h3 className="font-bold text-slate-800 mb-4">📣 Bulk SMS</h3>
              <div className="space-y-3 mb-4">
                <div>
                  <label className="label">Mobile Numbers *</label>
                  <textarea className="input" rows={5} value={bulkForm.mobiles} onChange={e=>setBulkForm({...bulkForm,mobiles:e.target.value})} placeholder="+254712345678&#10;+254722000111&#10;One number per line"/>
                  <p className="text-xs text-slate-400 mt-1">{bulkForm.mobiles.split('\\n').filter(m=>m.trim()).length} recipients</p>
                </div>
                <div>
                  <label className="label">Message *</label>
                  <textarea className="input" rows={4} value={bulkForm.message} onChange={e=>setBulkForm({...bulkForm,message:e.target.value})} placeholder="Your broadcast message..."/>
                </div>
              </div>
              <button onClick={()=>send('bulk-sms',{mobiles:bulkForm.mobiles.split('\\n').filter(m=>m.trim()),message:bulkForm.message})} disabled={loading||!bulkForm.mobiles||!bulkForm.message} className="btn-warning w-full">{loading?'Sending...':'📣 Send to All'}</button>
              <div className="mt-3 p-3 bg-amber-50 rounded-lg text-xs text-amber-700">⚠️ Bulk SMS will be sent to all listed numbers. Ensure compliance with DLT regulations.</div>
            </div>
          )}

          {tab==='templates'&&(
            <div className="card p-5">
              <h3 className="font-bold text-slate-800 mb-4">🎨 Notification Templates</h3>
              <div className="space-y-3">
                {/* Appointment Reminder */}
                <div className="border border-slate-200 rounded-xl p-4">
                  <div className="flex items-center gap-2 mb-3"><span className="text-xl">📅</span><h4 className="font-semibold text-slate-700">Appointment Reminder</h4></div>
                  <div className="grid grid-cols-2 gap-2 mb-3">
                    {[['patientName','Patient Name'],['mobile','Mobile'],['email','Email'],['doctorName','Doctor Name'],['date','Date'],['time','Time']].map(([k,l])=>(
                      <div key={k}><label className="label text-xs">{l}</label><Input className="text-xs" value={(apptForm as any)[k]} onChange={e=>setApptForm({...apptForm,[k]:e.target.value})} placeholder={l}/></div>
                    ))}
                  </div>
                  <button onClick={()=>send('appointment-reminder',apptForm)} disabled={loading} className="btn-primary w-full text-sm">{loading?'Sending...':'📱 Send Reminder (SMS + WhatsApp + Email)'}</button>
                </div>
                {/* Lab Report Ready */}
                <div className="border border-slate-200 rounded-xl p-4">
                  <div className="flex items-center gap-2 mb-3"><span className="text-xl">🔬</span><h4 className="font-semibold text-slate-700">Lab Report Ready</h4></div>
                  <div className="grid grid-cols-2 gap-2 mb-3">
                    {[['patientName','Patient Name'],['mobile','Mobile'],['email','Email']].map(([k,l])=>(
                      <div key={k}><label className="label text-xs">{l}</label><Input className="text-xs" value={(labForm as any)[k]} onChange={e=>setLabForm({...labForm,[k]:e.target.value})} placeholder={l}/></div>
                    ))}
                    <div className="col-span-2"><label className="label text-xs">Report Type</label><Input value={labForm.reportType} onChange={e=>setLabForm({...labForm,reportType:e.target.value})}/></div>
                  </div>
                  <button onClick={()=>send('lab-report-ready',labForm)} disabled={loading} className="btn-success w-full text-sm">{loading?'Sending...':'🔬 Notify Patient'}</button>
                </div>
                {/* Bill Receipt */}
                <div className="border border-slate-200 rounded-xl p-4">
                  <div className="flex items-center gap-2 mb-3"><span className="text-xl">💰</span><h4 className="font-semibold text-slate-700">Payment Receipt</h4></div>
                  <div className="grid grid-cols-2 gap-2 mb-3">
                    {[['patientName','Patient Name'],['mobile','Mobile'],['email','Email'],['billNumber','Bill Number'],['amount','Amount ({getCurrencySymbol()})','number']].map(([k,l,t])=>(
                      <div key={k}><label className="label text-xs">{l}</label><Input type={t||'text'} className="text-xs" value={(billForm as any)[k]} onChange={e=>setBillForm({...billForm,[k]:e.target.value})} placeholder={l}/></div>
                    ))}
                  </div>
                  <button onClick={()=>send('bill-receipt',billForm)} disabled={loading} className="btn-primary w-full text-sm">{loading?'Sending...':'💰 Send Receipt'}</button>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Result Panel */}
        <div>
          {result?(
            <div className="card p-5">
              <h3 className="font-semibold text-slate-700 mb-4">✅ Send Result</h3>
              {Array.isArray(result)?(
                <div className="space-y-2">
                  {result.map((r:any,i:number)=>(
                    <div key={i} className={`p-3 rounded-lg text-sm flex items-center gap-2 ${r.success?'bg-green-50 text-green-700':'bg-red-50 text-red-700'}`}>
                      <span>{r.success?'✅':'❌'}</span>
                      <span className="font-mono text-xs">{r.mobile}</span>
                      <span className="ml-auto">{r.demo?'Demo':'Sent'}</span>
                    </div>
                  ))}
                </div>
              ):(
                <div>
                  <div className={`p-4 rounded-xl mb-3 ${result.success!==false?'bg-green-50 border border-green-200':'bg-red-50 border border-red-200'}`}>
                    <p className={`font-semibold ${result.success!==false?'text-green-700':'text-red-700'}`}>{result.success!==false?'✅ Message sent successfully':'❌ Failed to send'}</p>
                    {result.demo&&<p className="text-amber-600 text-xs mt-1">🔧 Demo mode — configure API keys in .env for live sending</p>}
                    {result.messageId&&<p className="text-green-600 text-xs mt-1">Message ID: {result.messageId}</p>}
                  </div>
                  <pre className="text-xs font-mono bg-slate-50 p-3 rounded-lg overflow-x-auto">{JSON.stringify(result,null,2)}</pre>
                </div>
              )}
            </div>
          ):(
            <div className="card p-5">
              <h3 className="font-bold text-slate-800 mb-4">📋 Communication Channels</h3>
              <div className="space-y-3">
                {[
                  {icon:'📱',name:'SMS (MSG91)',desc:'Transactional & promotional SMS via DLT-registered sender. 160 chars per SMS.',status:'Configure API key in .env',color:'blue'},
                  {icon:'💬',name:'WhatsApp Business',desc:'Rich messages with media support via Meta Cloud API. Requires business verification.',status:'Configure WhatsApp Phone ID',color:'green'},
                  {icon:'📧',name:'Email (SMTP)',desc:'HTML emails via any SMTP provider. Supports attachments and templates.',status:'Configure SMTP credentials',color:'purple'},
                  {icon:'🔔',name:'Push Notifications',desc:'In-app and device push notifications via Firebase Cloud Messaging.',status:'Configure Firebase project',color:'amber'},
                  {icon:'📣',name:'Bulk Messaging',desc:'Send to thousands of patients at once with personalization.',status:'Uses configured channels',color:'red'},
                ].map(c=>(
                  <div key={c.name} className={`flex items-start gap-3 p-3 rounded-xl bg-${c.color}-50 border border-${c.color}-100`}>
                    <span className="text-2xl flex-shrink-0">{c.icon}</span>
                    <div>
                      <p className={`font-semibold text-${c.color}-800 text-sm`}>{c.name}</p>
                      <p className={`text-${c.color}-700 text-xs mt-0.5`}>{c.desc}</p>
                      <p className="text-xs text-slate-500 mt-1 font-mono bg-white/60 px-2 py-0.5 rounded inline-block">{c.status}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}
